<template>
    <div class="container">
        <h2 class="text-white mb-2"><img src="@/assets/logo-white.png" alt="ELSA" width="200px"/></h2>
        <ValidationObserver ref="observer"
                            tag="form"
                            class="row d-flex justify-content-center mx-2"
                            @submit.prevent="submit">
            <div class="col-xl-5 col-lg-7 col-md-9 bg-white shadow py-5 px-3 px-sm-5 rounded">
                <ValidationProvider tag="div"
                                    class="mb-4"
                                    vid="username"
                                    mode="lazy"
                                    :customMessages="{required: 'Norādi lietotājvārdu.'}"
                                    rules="required"
                                    v-slot="{errors}">
                    <label for="username" class="d-block text-secondary text-left mb-0">Lietotājvārds</label>
                    <input type="text" id="username" class="w-100 py-1 ds-input" v-model="loginForm.username">
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider tag="div"
                                    vid="password"
                                    mode="lazy"
                                    rules="required"
                                    :customMessages="{required: 'Norādi paroli.'}"
                                    v-slot="{errors}">
                    <label for="password" class="d-block text-secondary text-left mb-0">Parole</label>
                    <input type="password" id="password" class="w-100 py-1 ds-input" v-model="loginForm.password">
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>

                <CustomButton class="w-100" btn-text="Ienākt" :is-loading="isActiveRequest"/>
            </div>
        </ValidationObserver>
    </div>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';
    import {ValidationObserver, ValidationProvider, extend} from 'vee-validate';
    import {required} from 'vee-validate/dist/rules';

    import CustomButton from '@/components/global/CustomButton';
    import {LoginForm} from '../../vuex/modules/auth/modules/login/login-form.models';
    import * as authStoreTypes from '../../vuex/modules/auth/auth.store-types';
    import * as loginStoreTypes from '../../vuex/modules/auth/modules/login/login.store-types';
    import {CurrentUser} from '../../vuex/modules/auth/models/current-user';
    import * as rootStoreTypes from '../../vuex/root.store-types';

    export default {
        name: 'login',
        components: {
            CustomButton,
            ValidationProvider,
            ValidationObserver,
        },
        created: () => extend('required', required),
        data: () => ({
            loginForm: new LoginForm,
        }),
        methods: {
            ...mapMutations('auth', {
                /** @type {function|*} */
                setCurrentUser: authStoreTypes.SET_CURRENT_USER,
            }),
            ...mapMutations({
                /** @type {function|*} */
                setAlertData: rootStoreTypes.SET_ALERT_DATA,
            }),
            ...mapActions('auth/login', {
                /** @type {function|*} */
                login: loginStoreTypes.ACTION_LOGIN,
            }),
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if (!isValid) {
                    return;
                }

                try {
                    const userData = await this.login(this.loginForm);
                    const user = CurrentUser.fromArray(userData);
                    this.setCurrentUser(user);
                    this.reset();
                    await this.$router.push({name: 'index'});

                    if (user.hasOutdatedPassword) {
                        this.setAlertData({
                            type: 'warning',
                            message: 'Jūsu parole tiek lietota ilgāk par 3 mēnešiem, sistēmas izmantošanas drošības nolūkos ieteicams to nomainīt.',
                            linkData: {
                                routeName: 'user-profile',
                                linkTitle: 'Doties uz profila sadaļu.'
                            },
                            dismissSecs: 999,
                        });
                    }
                } catch (error) {
                    this.$refs.observer.setErrors({[error.field]: [error.message]});
                }
            },
            reset() {
                this.loginForm = new LoginForm;
                this.$refs.observer.reset();
            },
        },
        computed: mapGetters('auth/login', {
            /** @type {boolean|*} */
            isActiveRequest: loginStoreTypes.GET_IS_ACTIVE_REQUEST,
        }),
    }
</script>